<a class="hidden-link" tabindex="0" href="#input" translate="">lbl_skip_main_content_accessibility</a>
<div class="company-logo">
  <img src="/assets/images/shuttle_login_logo_black.png" alt="logo">
</div>
<p-panelMenu class="sidebar-panel-menu" [model]="items" [multiple]="false"></p-panelMenu>